export default __webpack_public_path__ + "static/media/proximanova-light.7d9ff7d4.otf";